const langReducer = (state = "en", action) => {
  switch (action.type) {
    case "SET_LANGUAGE":
      return action.lang;
    default:
      return state;
  }
};

export default langReducer;
